import styled, { useTheme } from "styled-components";
import arrowDownImg from "../../assets/img/arrow-down.svg";
import ReactSelect from "react-select";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";

const SelectContainer = styled("div")(() => ({}));

const StyledSelect = styled(ReactSelect)(() => ({}));

const StyledCreatableSelect = styled(CreatableSelect)(() => ({}));

const Error = styled.div(({ theme }) => ({
  fontSize: 12,
  color: theme.color.error,
  marginTop: "0.5em",
}));

const Label = styled("div")(({ theme }) => ({
  fontSize: 14,
  color: theme.color.label,
  fontWeight: 400,
  letterSpacing: 0.32,
  textAlign: "start",
  lineHeight: 3,
}));

const StyleStartImg = styled.img(() => ({
  width: 22,
  height: 22,
  marginInlineStart: "1em",
  alignSelf: "center",
}));

const Select = ({
  label,
  value,
  error,
  name,
  options,
  onChange,
  width,
  height,
  helperText,
  startImg,
  placeholder,
  clearable,
  creatable,
  isMulti = false,
  isMobile,
  ...props
}) => {
  const theme = useTheme();
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <img src={arrowDownImg} alt="input-sown-img" />
      </components.DropdownIndicator>
    );
  };

  const Control = ({ children, ...props }) => {
    return (
      <components.Control {...props}>
        {!!startImg && <StyleStartImg src={startImg} alt="input-start-img" />}
        {children}
      </components.Control>
    );
  };

  return (
    <SelectContainer style={{ ...props.style }}>
      {label && <Label>{label}</Label>}
      {creatable ? (
        <StyledCreatableSelect
          isClearable={clearable === false ? false : true}
          styles={{
            container: (base) => ({
              ...base,
              fontSize: 14,
              backgroundColor: theme.color.gray10,
              borderRadius: 21,
              width: width ? width : "100%",
              border:
                !!helperText === true
                  ? `1px solid ${theme.color.error}`
                  : `1px solid ${theme.color.primary}`,
            }),
            control: (base) => ({
              ...base,
              display: "flex",
              alignItems: "center", // ⬅️ Vertically center
              backgroundColor: theme.color.gray10,
              boxShadow: 0,
              border: 0,
              borderRadius: 21,
              padding: isMobile ? "0 12px" : 6, // ⬅️ Left-right only on mobile
              width: "100%",
              fontSize: 14,
              height: isMobile ? 42 : "unset", // ⬅️ Fixed height for mobile
            }),
            input: (base) => ({
              ...base,
              fontSize: 14,
              color: theme.color.navy,
              fontWeight: 400,
              letterSpacing: 0.32,
              borderRadius: 21,
              padding: "10px 20px 10px 20px",
              textAlign: "start",
            }),
            indicatorSeparator: () => { },
            menuList: (base) => ({
              ...base,
              marginRight: 5,
              fontSize: 14,
            }),
            placeholder: (base) => ({
              ...base,
              textAlign: "right",
              color: theme.color.gray70,
              fontSize: props.style?.fontSize || 14,
            }),
          }}
          isMulti={isMulti}
          closeMenuOnSelect={true}
          components={{ DropdownIndicator, Control }}
          options={options}
          mame={name}
          value={value}
          defaultValue={value}
          onChange={onChange}
          notEmpty={value !== "none"}
          placeholder={value && value !== "none" ? value : placeholder}
        ></StyledCreatableSelect>
      ) : (
        <StyledSelect
          isClearable={clearable === false ? false : true}
          styles={{
            container: (base) => ({
              ...base,
              backgroundColor: theme.color.gray10,
              borderRadius: 21,
              width: width ? width : "100%",
              fontSize: 14,
              padding: isMobile ? 0 : "inherit",
              // height: isMobile ? 42 : "unset",
              border:
                !!helperText === true
                  ? `1px solid ${theme.color.error}`
                  : `1px solid ${theme.color.primary}`,
            }),
            control: (base) => ({
              ...base,
              backgroundColor: theme.color.gray10,
              boxShadow: 0,
              border: 0,
              borderRadius: 21,
              padding: isMobile ? 0 : 0,
              width: "100%",
              fontSize: 14,
              height: isMobile ? 40 : "unset",
            }),
            singleValue: (base) => ({
              ...base,
              width: width ? width : "100%",
            }),
            input: (base) => ({
              ...base,
              fontSize: 14,
              color: theme.color.navy,
              fontWeight: 400,
              letterSpacing: 0.32,
              borderRadius: 21,
              // padding: "10px 20px 10px 20px",
              textAlign: "start",
            }),
            indicatorSeparator: () => { },
            menuList: (base) => ({
              ...base,
              marginRight: 0,
              fontSize: 14,
            }),
            placeholder: (base) => ({
              ...base,
              textAlign: "right",
              color: theme.color.gray70,
              fontSize: props.style?.fontSize || 14,
            }),
          }}
          isMulti={isMulti}
          closeMenuOnSelect={true}
          components={{ DropdownIndicator, Control }}
          options={options}
          mame={name}
          value={value}
          defaultValue={value}
          onChange={onChange}
          notEmpty={value !== "none"}
          placeholder={value && value !== "none" ? value : placeholder}
        ></StyledSelect>
      )}
      {!!helperText && <Error>{helperText}</Error>}
    </SelectContainer>
  );
};

export default Select;
